"use strict";

exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Get run index that contains passed index
 *
 * @param  {number}  char index
 * @param  {Array}  runs array
 * @return {Array} run index
 */
var runIndexAt = function runIndexAt(x, runs) {
  // binary search to find the index
  var n = runs.length;
  var k = -1;
  var ok = function ok(v) {
    return v >= n || x < runs[v].end;
  };
  for (var b = n; b >= 1; b = Math.floor(b / 2)) {
    while (!ok(k + b)) k += b;
  }
  // no results found
  if (k + 1 === runs.length) return -1;
  return k + 1;
};
var _default = exports.default = R.curryN(2, runIndexAt);